const regExp ={
  0 : /[0-9]/,
};

function beforeInputHandler (event, pattern, setCallback) {
  event.preventDefault();
  let val = event.target.value;
  let selectionStart = event.target.selectionStart;
  let selectionEnd = event.target.selectionEnd;
  let unmaskedValue = unmask(val, pattern);
  let result;
  let deletePosStart = selectionStart;
  let deletePosEnd = selectionEnd;
  let insertPosStart;
  let insertPosEnd;
  let eventValue = event.data;
  let unmaskedEventValue;
  /* fix for phone */
  if (pattern.substring(0, 2) === '+7') {
    if (!event.target.value && (String(event.data) === '8' || String(event.data) === '7')) {
      eventValue = '';
    }
  }

  switch (event.inputType) {
    case 'insertText':
      insertPosStart = selectionStart;
      insertPosEnd = selectionEnd;

      for (let i = 0; i < selectionStart; i++) {
        if (!regExp[pattern[i]]) {
          insertPosStart -= 1;
          insertPosEnd -= 1;
        }
      }
      for (let i = selectionStart; i <= pattern.length; i++) {
        selectionStart += 1;
        if (regExp[pattern[i]]) {
          if (!regExp[pattern[i]].test(eventValue)) {
            selectionStart -= 1;
          }
          break;
        }
      }
      unmaskedValue = unmaskedValue.substring(0, insertPosStart) + eventValue + unmaskedValue.substring(insertPosEnd);
      result = applyPattern(unmaskedValue, pattern);

      break;
    case 'insertReplacementText':
      unmaskedValue = unmask(eventValue, pattern);
      result = applyPattern(unmaskedValue, pattern);
      selectionStart = result.search('_') > -1
          ? (result.search('_'))
          : pattern.length;
      break;
    case 'deleteContentBackward':
      for (let i = 0; i < selectionEnd; i++) {
        if (!regExp[pattern[i]]) {
          deletePosStart -= 1;
          deletePosEnd -= 1;
        }
      }
      for (let i = selectionStart - 1; i >= 0; i--) {
        selectionStart -= 1;
        if (regExp[pattern[i]]) {
          break;
        }
      }
      if (deletePosStart !== deletePosEnd) {
        unmaskedValue = unmaskedValue.substring(0, deletePosStart) +
            unmaskedValue.substring(deletePosEnd);
      } else {
         unmaskedValue = unmaskedValue.substring(0, deletePosStart - 1) +
             unmaskedValue.substring(deletePosStart);
      }

      result = unmaskedValue ? applyPattern(unmaskedValue, pattern) : '';
      break;
    case 'deleteContentForward':
    case 'deleteByCut':

      for (let i = 0; i < selectionEnd; i++) {
        if (!regExp[pattern[i]]) {
          deletePosStart -= 1;
          deletePosEnd -= 1;
        }
      }

       for (let i = selectionStart; i < selectionEnd; i++) {
         if (!regExp[pattern[i]]) {
           deletePosStart += 1;
         }
      }
      if (deletePosStart !== deletePosEnd) {
        unmaskedValue = unmaskedValue.substring(0, deletePosStart) +
            unmaskedValue.substring(deletePosEnd);
      } else {
         unmaskedValue = unmaskedValue.substr(0, deletePosStart) +
             unmaskedValue.substr(deletePosStart + 1);
      }
      result = unmaskedValue ? applyPattern(unmaskedValue, pattern) : '';
      break;
    case 'insertFromPaste':
      /* fix for phone */
      if (pattern.substring(0, 2) === '+7' || pattern.substring(0, 1) === '8') {
        let clearedPhone = /[\s()+-]/[Symbol.split](eventValue).join('');
        unmaskedEventValue = clearedPhone.substr(-10);
      } else {
        unmaskedEventValue = unmask(eventValue, pattern);
      }
      result = applyPattern(unmaskedEventValue, pattern);
      break;
    default:
      return;
  }

  event.target.value = result;
  event.target.selectionStart = selectionStart;
  event.target.selectionEnd = selectionStart;
  setCallback(result);
}
function blurHandler(event, pattern, setCallback) {
  if (unmask(event.target.value, pattern) === '') {
    setCallback(unmask(event.target.value, pattern));
  }
}
function focusHandler(event, pattern, setCallback) {
  let caretPos;
  if (event.target.value === '') {
    if (pattern.substring(0, 2) !== '+7') {
      let emptyPatternValue = applyPattern('', pattern);
      setCallback(emptyPatternValue);
      caretPos = emptyPatternValue.search('_');
    }
  } else {
    caretPos = event.target.value.search('_');
  }
  setTimeout(() => {
    event.target.selectionStart = caretPos;
    event.target.selectionEnd = caretPos;
  });
}

function applyPattern(val, pattern) {
  let re, i = 0, result = '';
  for (let pos in pattern) {
    re = regExp[pattern[pos]];
    if (re) {
      result += re.test(val[i]) ? val[i] : '_';
      i++;
    } else {
      result += pattern[pos];
    }
  }
  return result;
}

function unmask(val, pattern) {
  let re, result='';
  for (let pos in pattern) {
    re = regExp[pattern[pos]];
    if (re && re.test(val[pos])) {
      result += val[pos];
    }
  }
  return result;
}

export {beforeInputHandler, focusHandler, blurHandler}